/**
 * Landing buttons (Falcon order page buttons, funnel links) carry the offer the
 * visitor clicked on as `addChoices=<choiceId>[,<choiceId>]`. That choice is an
 * explicit visitor intent and always wins over any catalog-level preselection.
 *
 * `addChoices=true` is the legacy one-click marker, not a choice list.
 */
export function getRequestedChoiceIds(searchParams) {
  if (!searchParams?.get) {
    return [];
  }

  const value = searchParams.get("addChoices");
  if (value == null || value === "true") {
    return [];
  }

  return value
    .split(",")
    .map((choiceId) => choiceId.trim())
    .filter((choiceId) => choiceId.length > 0);
}

export function hasRequestedChoiceIds(searchParams) {
  return getRequestedChoiceIds(searchParams).length > 0;
}
